<template>
  <div class="lector">
    <v-img
      width="250"
      height="300"
      :src="
        person.img ? require(`@/assets/img/lectures2025/${person.img}`) : ''
      "
      class="lector-img"
      @mouseover="hover = true"
      @mouseout="hover = false"
      @click="$router.push(`/lector/${person.id}`)"
      :position="person.id === 6 ? 'start center' : 'top center'"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            v-if="person.img"
            indeterminate
            color="#FFA903"
          />
        </v-row>
      </template>
      <div
        id="shadow"
        class="shadow"
        :style="{ opacity: hover ? 0.8 : 0 }"
      ></div>
      <div
        class="lector-name"
        :style="{ color: hover ? '#FFA903' : 'inherit' }"
      >
        <h2 class="px-2 pb-0">
          {{ person.firstName }}
        </h2>
        <h2 class="px-2 pb-0">
          {{ person.lastName }}
        </h2>
      </div>
    </v-img>
    <h5 class="px-2 my-5">{{ person.rank }}</h5>
    <p v-if="person.theme" class="px-2">
      {{ lectorsData.topicsLabel }}: «{{ person.theme }}»
    </p>

    <p v-if="person.discussionTheme" class="px-2">
      {{ lectorsData.discussionClubLabel }}: «{{ person.discussionTheme }}»
    </p>

    <p v-if="person.interview" class="px-2">
      {{ lectorsData.interviewLabel }}: «{{ person.interview }}»
    </p>
  </div>
</template>

<script>
export default {
  name: "lector",
  props: ["person"],
  computed: {
    lectorsData() {
      return this.$t("lectors");
    }
  },
  data: () => ({
    hover: false
  })
};
</script>

<style lang="sass" scoped>
@import "src/assets/style/vars"

.lector
  outline: none !important
  width: 17rem !important
  overflow: hidden
  &-img
    position: relative
    transition: all .2s ease
    background-color: $light
  &-name
    position: absolute !important
    bottom: 0 !important
    left: 0 !important
    cursor: pointer
    h2
      font-size: 1.5rem
      line-height: 2rem
      background-color: #FFFFFF
      width: max-content
      transition: all .3s ease
  p
    color: #CECED8

.shadow
  width: 100%
  height: 100%
  position: absolute
  cursor: pointer
  top: 0
  left: 0
  background-color: rgba(47, 46, 67)
  opacity: 0
  transition: all .3s ease
</style>
